// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"48ff9fb4","251":"ab74676b","320":"62d40f36","587":"346448c9","605":"2f5cb34f","848":"edbd4a90","897":"3c3ec02d","966":"6f022057"}[chunkId] + ".chunk.js";
};